export default "__VITE_ASSET__D45fA6CG__";